import { AsyncSelect, FormGroup } from '@ksyos/design-system';
import { useState } from 'react';
import type { IOption } from '@frontend/components/interfaces';
import { getSelectedLanguage } from '@frontend/translate';
import { useAbortableFetch } from '@frontend/utils';
import type { IGroup } from '../../../groups/groupsAddEdit/GroupsAddEdit';

interface IPaymentsGroupFilterProps {
    groupId?: string;
    onChangeGroup: (value?: string) => void;
}

export function PaymentsGroupFilter(props: IPaymentsGroupFilterProps) {
    const language = getSelectedLanguage();
    const abortableFetch = useAbortableFetch();

    const [groupFilterValues, setGroupFilterValues] = useState<IOption<string>[]>([]);

    return (
        <FormGroup label={language.groups.group}>
            <AsyncSelect
                cacheOptions={true}
                defaultOptions={true}
                isClearable={true}
                loadOptions={async (searchTerm) => await loadGroupFilters(searchTerm)}
                onChange={(item) => props.onChangeGroup(item ? item.value : undefined)}
                value={props.groupId ? groupFilterValues.find((item) => item.value === props.groupId) : undefined}
            />
        </FormGroup>
    );

    async function loadGroupFilters(input: string) {
        const result = await abortableFetch.fetchJson(`/api/groups?searchText=${input}`, 'GET');
        const options = result.json.items.map((group: IGroup) => ({
            label: group.name,
            value: group.id,
        })) as IOption<string>[];
        setGroupFilterValues(options);

        return options;
    }
}
